import { useContext, useState } from "react";
import { getLabel } from '../../data/labels';
import MainContext from "../../contexts/MainContext";
import { getConfiguration } from "../../data/utils";
import AzotoPlayer from "../../prematch/prematch-home/prematch-home-video/AzotoPlayer";
import ClapprPlayer from "../../prematch/prematch-home/prematch-home-video/ClapprPlayer";
import StreamingButton from '../../prematch/prematch-home/prematch-home-video/StreamingButton';
import NewSource from './NewsSource';
import { isBotAgent } from "../../data/sport-utils";

export default function LiveTv(props) {
    const conf = getConfiguration();
    const mainContext = useContext(MainContext);
    const [showedChannel, setShowedChannel] = useState(0);
    const videoChannelList = conf?.phvn?.length > 0 ? conf?.phvn.filter((p) => {return p.cntnrd == props.container})  : []; // If conf.phvn.cntnrd is set (e.g. cntnrd=='betslip' ), will be showed in the appropriate container
    const videoChannel = videoChannelList?.[showedChannel];
    const streamingId = mainContext.streamingId;

    return (
        <>
            {!streamingId && !isBotAgent() && videoChannel  &&
                <>  
                    <div id="live-tv-container">
                        {videoChannelList.length > 1 &&
                            <div className="live-tv-header">
                                <div className="streaming-tv-buttons-channel-container">
                                    <StreamingButton obj={videoChannelList[0]}
                                                    index={0}
                                                    current={showedChannel}
                                                    setChannel={setShowedChannel}
                                    />
                                </div>
                                <div className="live-tv-title d-flex align-items-center w-100" >
                                    {getLabel('prematch_page.home_video.title')}
                                </div>
                                <div className="streaming-tv-buttons-channel-container">
                                    {videoChannelList.map((obj, index) => {
                                        if (index > 0) {
                                            return (
                                                <StreamingButton key={`button-streaming-${index}`}
                                                                obj={obj}
                                                                index={index}
                                                                current={showedChannel}
                                                                setChannel={setShowedChannel}
                                                />
                                            );
                                        }
                                        return null;
                                    })}
                                </div>
                            </div>
                        }
                        <div id="live-tv-player-container">
                            {(videoChannel.pty === 'clappr' || videoChannel.pty === 'silive') && 
                                <ClapprPlayer key={videoChannel.pty} playerUrl={videoChannel.pju} streamSource={videoChannel.pssu} />    
                            }
                            {(videoChannel.pty === 'azoto') && 
                                <AzotoPlayer key={videoChannel.pty} iframeSource={videoChannel.pssu} />    
                            }
                        </div>
                        {videoChannel.unws &&
                            <NewSource src={videoChannel.unws} />
                        }
                    </div>
                </>
            }
        </>
    )
}
